module.exports = __webpack_public_path__ + "images/a0804bbbfe325aaf5ba2dbecce41c631.svg";